exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".UVSessionComparisonGraph_root{position:relative}.UVSessionComparisonGraph_aggregation_method_select{position:absolute;right:0;margin-top:30px}\n", ""]);

// Exports
exports.locals = {
	"root": "UVSessionComparisonGraph_root",
	"aggregation_method_select": "UVSessionComparisonGraph_aggregation_method_select"
};